import { acceptHMRUpdate, defineStore } from 'pinia'
import type { VenuePosType } from '@/types/venue-pos.type.js'
import { useUserStore } from './user'
import { PosLocation } from '@/enums/pos-type.enum'

interface State {
  venuePos?: VenuePosType[]
  connection: Record<string, any>
}

export const useVenuePosStore = defineStore('venuePos', {
  state: (): State => {
    return {
      venuePos: undefined,
      connection: {}
    }
  },
  getters: {
    hasPOSConnected: (state) => {
      return (state.venuePos?.length ?? 0) > 0
    },
    hasCurrentVenuePOSConnected: () => {
      const userStore = useUserStore()
      const currentVenue = userStore.currentVenue?.pos
      return currentVenue?.has_location === 1
    }
  },
  actions: {
    async getVenuePos() {
      const venuePos: VenuePosType[] = await $.get('/venue-pos')
      this.venuePos = venuePos
    },
    async getSquareConnection(payload: any) {
      const connection = await $.post('/pos-auth/square-callback', payload)
      this.connection = connection
      return connection
    },
    async getCloverConnection(payload: any) {
      const connection = await $.get('/pos-auth/clover-callback', payload)
      this.connection = connection
      return connection
    },
    async getShift4Connection(payload: any) {
      const connection = await $.post('/pos-auth/shift4-callback', payload)
      this.connection = connection
      return connection
    },
    async updatePosLocation(location: PosLocation) {
      await $.ajax({
        url: '/venue-pos',
        method: 'PUT',
        data: { location }
      })
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useVenuePosStore, import.meta.hot))
}
